<!--
/*******************************************************************************
*@ 컴포넌트명   : AccountSearchBox.vue
*@ 컴포넌트설명 : 검색조건
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 조회결과가 없음 -->
    <div class="empty" v-if="showOption.includes('acno') && this.list.length == 0">
      <div class="empty-img">
        <i class="icon icon-opt-no" />
      </div>
      <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
    </div>
    <!--// 조회결과 없음 end -->
    <template v-else>
      <!-- 계좌번호 -->
      <div class="account-info" v-if="showOption.includes('acno')">
        <template v-if="acnDtailCd == '6' || acnDtailCd == '4'">
          <!-- 예금/적금거래내역 조회시 -->
          <div class="item title">
            <div class="account" @click="actionSheetOpened = true">
              {{ acnoParam.acno }} ({{ acnoParam.alias }})
              <i class="icon icon-arrow-right" />
            </div>
          </div>
          <div class="item date">{{ /*만기일*/ $t("MCOM-0000086") }} : {{ $getGlobalDateFmt(acnoParam.expirYmd) }}</div>
          <div class="item etc">{{ /*예금 이율*/ $t("MCOM-0000087") }} : {{ acnoParam.dpostIrt }}%</div>
          <div class="item amount">
            <span class="exchange-unit">{{ acnoParam.cncycd }}</span>
            <span class="total" v-html="$num(acnoParam.bal, null, true)"></span>
          </div>
        </template>
        <template v-else-if="acnDtailCd == '5' || $route.params.page == 'rpayRsultInq'">
          <!-- 대출거래내역 조회시 / 과거대출내역에서 거래내역으로 이동했을 때 -->
          <div class="item title">
            <div class="account" @click="actionSheetOpened = $route.params.page != 'rpayRsultInq'">
              {{ acnoParam.acno }}({{ acnoParam.alias }})
              <i v-if="$route.params.page != 'rpayRsultInq'" class="icon icon-arrow-right" />
            </div>
          </div>
          <div class="item date">{{ /*다음 납입일*/ $t("MCOM-0000088") }}: {{ $getGlobalDateFmt(acnoParam.nxtrmPaymtYmd) }}</div>

          <div class="item etc">{{ /*Loan Rate*/ $t("MCOM-0000089") }} : {{ acnoParam.lnIrt }}%</div>
          <div class="item amount">
            <span class="exchange-unit">{{ acnoParam.cncycd }}</span>
            <span class="total" v-html="$num(acnoParam.lnBal, null, true)"></span>
          </div>
        </template>
        <template v-else>
          <div class="item title">
            <div class="account" @click="actionSheetOpened = true">
              {{ acnoParam.acno }}
              <span class="nation">({{ acnoParam.cncycd }})</span>
              <i class="icon icon-arrow-right" />
            </div>
          </div>
          <div class="item name">{{ acnoParam.acnoAls }}</div>
          <div class="item date" v-if="$route.name != 'trsaccRsultInq' && $route.name != 'fcTrsaccRsultInq'">{{ $getGlobalDateFmt(acnoParam.newYmd) }}</div>
          <div class="item amount">
            <span class="exchange-unit">{{ acnoParam.cncycd }}</span>
            <span class="total" v-html="$num(acnoParam.bal, null, true)"></span>
          </div>
        </template>
      </div>
      <div class="fillter" v-if="!(showOption.length == 1 && showOption[0] == 'acno')">
        <ul class="fillter-list">
          <!-- 조회구분 - 과거대출내역조회 -->
          <li v-if="showOption.includes('chnlDstcd')">
            <span class="item" @click="filterOpeneded = true">{{ $t(_.filter(chnlDstcdList, { value: srchParam.chnlDstcd || chnlDstcdDefault })[0].text) }}</span>
          </li>
          <!-- 조회기간 - 결제내역조회(BillPayment) - 전체/전기요금/수도요금 -->
          <li v-if="showOption.includes('paymtCalRange')">
            <span class="item" @click="filterOpeneded = true">{{ $t(_.filter(paymtDsticCdList, { value: srchParam.billPaymentDstcCd })[0].text) }}</span>
          </li>

          <!-- 조회기간 -->
          <li v-if="showOption.includes('calRange')">
            <span class="item" @click="filterOpeneded = true">{{ $getGlobalDateFmt(srchParam.tranStartYmd) }} ~ {{ $getGlobalDateFmt(srchParam.tranEndYmd) }}</span>
          </li>
          <!-- 조회내용 -->
          <li v-if="showOption.includes('inotDstcd')">
            <span class="item" @click="filterOpeneded = true">{{ $t(_.filter(inotDstcdList, { value: srchParam.brncoInotDstcd || inotDstcdDefault })[0].text) }}</span>
          </li>
          <!-- 조회구분 - 거래내역조회 -->
          <li v-if="showOption.includes('resultSeq')">
            <span class="item" @click="filterOpeneded = true"
              >{{ _.filter(resultSeqList, { value: srchParam.resultSeq || resultSeqDefault })[0].value == "01" ? "▲" : "▼" }} new</span
            >
          </li>
          <!-- 조회구분 - 외화이체신청내역조회 -->
          <li v-if="showOption.includes('fcResultSeq')">
            <span class="item" @click="filterOpeneded = true"
              >{{ _.filter(fcResultSeqList, { value: srchParam.fcResultSeq || fcResultSeqDefault })[0].value == "1" ? "▲" : "▼" }} new</span
            >
          </li>
          <!-- 조회구분 - 예금해지/갱신 -->
          <li v-if="showOption.includes('inqueryDst')">
            <span class="item" @click="filterOpeneded = true">{{ $t(_.filter(inqueryDstList, { value: srchParam.inqueryDst || inqueryDstDefault })[0].text) }}</span>
          </li>

          <!-- 거래 종류(결재완료내역) -->
          <li v-if="showOption.includes('corpBzwkCd')">
            <span class="item" @click="filterOpeneded = true" v-if="srchParam.corpBzwkCd != '0'">
              {{ $t(_.filter(corpBzwkCdList, { value: srchParam.corpBzwkCd || corpBzwkCdDefault })[0].text) }}
            </span>
          </li>

          <!-- 출금계좌번호(결재완료내역) -->
          <li v-if="showOption.includes('acno2')">
            <span class="item" @click="filterOpeneded = true" v-if="acnoParam.acno">{{ acnoParam.acno }}</span>
          </li>

          <!-- 등록자(결재완료내역)-->
          <li v-if="showOption.includes('regiWwwBnkgLginId')">
            <span class="item" @click="filterOpeneded = true" v-if="regiWwwBnkgLginName != ''">{{ regiWwwBnkgLginName }}</span>
          </li>

          <!-- 결재 상태(결재완료내역) -->
          <li v-if="showOption.includes('aprvalDstic')">
            <span class="item" @click="filterOpeneded = true">{{ $t(_.filter($config.APRVAL_STATUS_CD2, { value: srchParam.aprvalDstic || aprvalStusDefault })[0].text) }}</span>
          </li>

          <slot name="tag" />
        </ul>
        <div class="fillter-option" @click="filterOpeneded = true">
          <i class="icon icon-fillter" />
        </div>
      </div>
    </template>

    <!-- 계좌번호 -->
    <action-sheet :opened.sync="actionSheetOpened" :action-footer="false" title="MDEP-02-01-08-06" class="action-sheet action-sheet--list-type">
      <template #content>
        <ul>
          <li v-for="(op, i) in list" :key="i" @click="optionClick(op, i)">
            <search-acno-template :is-bookmark="true" :acno="op.value" />
          </li>
        </ul>
      </template>
    </action-sheet>
    <!--// 계좌번호 -->
    <!-- 검색조건 -->
    <popup
      :opened.sync="filterOpeneded"
      :use-footer="true"
      :title="title"
      :class="[isCalendarOpen || isNoScroll ? 'no-scroll' : '']"
      :visible="($route.name == 'historyList' && $bridge.isIos()) || ($route.name == 'paymentHistory3' && $bridge.isIos())"
    >
      <template #content>
        <!-- 검색 조건 search-condition -->
        <article class="contents search-condition">
          <div class="form">
            <!-- 조회구분 - 과거대출내역조회 -->
            <div class="form-row" v-if="showOption.includes('chnlDstcd')">
              <radio-box
                ref="chnlDstcd"
                id="chnlDstcd"
                title-i18n="MCOM-0000056"
                :data-list="chnlDstcdList"
                :value.sync="param_.chnlDstcd"
                :default-checked-value="param_.chnlDstcd || chnlDstcdDefault"
                :is-horizontal="true"
              />
            </div>

            <!-- 송금방식(인도) -->
            <div class="form-row" v-if="showOption.includes('rmtancPtrnDstcd')">
              <select-box
                id="rmtancPtrnDstcd"
                ref="rmtancPtrnDstcd"
                :value.sync="param_.rmtancPtrnDstcd"
                :option-list="rmtancPtrnDstcdList"
                label-i18n="MPAY-02-01-24-10"
                defaultText="MCOM-0000061"
              />
            </div>
            <!-- Bill Payment 결제내역조회때 검색 조건 & 거래 처리-->
            <div class="form-row" v-if="showOption.includes('paymtCalRange')">
              <select-box
                id="billPaymentDstcCd"
                ref="billPaymentDstcCd"
                :option-list="paymtDsticCdList"
                label-i18n="MPAY-06-01-01-57"
                :value.sync="param_.billPaymentDstcCd"
                class="item-tit"
                defaultText="MCOM-0000061"
              />
            </div>

            <!-- 조회기간 -->
            <div class="form-row" v-if="showOption.includes('calRange')">
              <calendar-range
                ref="calRange"
                title-i18n="MCOM-0000057"
                :from-date.sync="param_.tranStartYmd"
                :to-date.sync="param_.tranEndYmd"
                :default-range-index="defaultRangeIndex"
                :range-option="rangeOption"
                @calendarOpen="v => (isCalendarOpen = v)"
              />
            </div>

            <!-- 조회내용 -->
            <div class="form-row" v-if="showOption.includes('inotDstcd')">
              <radio-box
                ref="inotDstcd"
                id="inotDstcd"
                title-i18n="MCOM-0000058"
                :data-list="inotDstcdList"
                :value.sync="param_.brncoInotDstcd"
                :default-checked-value="param_.brncoInotDstcd || inotDstcdDefault"
                :is-horizontal="true"
              />
            </div>

            <!-- 조회구분 - 거래내역조회 -->
            <div class="form-row" v-if="showOption.includes('resultSeq')">
              <radio-box
                ref="resultSeq"
                id="resultSeq"
                title-i18n="MCOM-0000056"
                :data-list="resultSeqList"
                :value.sync="param_.resultSeq"
                :default-checked-value="param_.resultSeq || resultSeqDefault"
              />
            </div>

            <!-- 조회구분 - 외화이체신청내역조회 -->
            <div class="form-row" v-if="showOption.includes('fcResultSeq')">
              <radio-box
                ref="fcResultSeq"
                id="fcResultSeq"
                title-i18n="MCOM-0000056"
                :data-list="fcResultSeqList"
                :value.sync="param_.fcResultSeq"
                :default-checked-value="param_.fcResultSeq || fcResultSeqDefault"
              />
            </div>

            <!-- 조회구분 - 예금해지/갱신 -->
            <div class="form-row" v-if="showOption.includes('inqueryDst')">
              <radio-box
                ref="inqueryDst"
                id="inqueryDst"
                title-i18n="MCOM-0000056"
                :data-list="siteCode == $config.SITECODE_OGMMR ? inqueryDstList_ogmmr : inqueryDstList"
                :value.sync="param_.inqueryDst"
                :default-checked-value="param_.inqueryDst || siteCode == $config.SITECODE_OGMMR ? '1' : inqueryDstDefault"
                :is-horizontal="true"
              />
            </div>
            <!-- 입금 계좌번호 -->
            <div class="form-row" v-if="showOption.includes('mnrcvAcno')">
              <input-text ref="mnrcvAcno" id="mnrcvAcno" :value.sync="param_.mnrcvAcno" label-i18n="MCOM-0000059" alphaNumOnly />
              <input type="hidden" :value="slots" />
            </div>

            <!-- 거래 종류(결재완료내역) -->
            <div class="form-row" v-if="showOption.includes('corpBzwkCd')">
              <select-box id="corpBzwkCd" ref="corpBzwkCd" :value.sync="param_.corpBzwkCd" :option-list="corpBzwkCdList" label-i18n="PCOP-02-02-02-03" defaultText="MCOM-0000061" />
            </div>

            <!-- 출금계좌번호(결재완료내역) -->
            <div class="form-row" v-if="showOption.includes('acno2')">
              <!-- <acno-select-box
                ref="acno2"
                in-acn-knd="1"
                in-acn-dtl-knd="2"
                :value.sync="param_.acno2"
                label-i18n="PCOP-02-02-03-06"
                @change="acno2Change"
              />-->
            </div>
            <!-- 등록자(결재완료내역) -->
            <div class="form-row" v-if="showOption.includes('regiWwwBnkgLginId')">
              <select-box
                id="regiWwwBnkgLginId"
                ref="regiWwwBnkgLginId"
                :value.sync="param_.regiWwwBnkgLginId"
                :option-list="regiWwwBnkgLginIdList"
                label-i18n="PCOP-02-02-03-07"
                defaultText="MCOM-0000061"
                @change="regiWwwBnkgLginIdChange"
              />
            </div>

            <!-- 결재 상태(결재완료내역) -->
            <div class="form-row" v-if="showOption.includes('aprvalDstic')">
              <radio-box
                id="aprvalDstic"
                ref="aprvalDstic"
                :value.sync="param_.aprvalDstic"
                :data-list="$config.APRVAL_STATUS_CD2"
                titleI18n="MCOM-0000122"
                :default-checked-value="param_.aprvalDstic || inqueryDstDefault"
                :is-horizontal="true"
              />
            </div>
          </div>
          <slot name="notice" />
        </article>
      </template>
      <template #footer>
        <template v-if="$route.name == 'historyList' && $bridge.isIos()">
          <button v-show="hideSearchButton()" class="btn md normal" @click="confirm">{{ $t(buttonTitle) }}</button>
        </template>
        <!-- 결제내역조회 -->
        <template v-else-if="$route.name == 'paymentHistory3' && $bridge.isIos()">
          <button v-show="hideSearchButton()" class="btn md normal" @click="confirm">{{ $t(buttonTitle) }}</button>
        </template>
        <template v-else>
          <div class="btn-area--full">
            <button v-show="hideSearchButton()" class="btn md normal" @click="confirm">{{ $t(buttonTitle) }}</button>
          </div>
        </template>
      </template>
    </popup>
    <!-- //검색조건 -->
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { RBF0404F40 } from "@/mixins/wholAcnInq";
import { RBF0400A40 } from "@/mixins/transfer";
import { calendarRangeDateSet } from "@/mixins/basicComponent";
import SearchAcnoTemplate from "@/components/template/SearchAcno";
//import AcnoSelectBox from "@/components/page/common/AcnoSelectBox";
export default {
  name: "AccountSearchBox",
  mixins: [RBF0404F40, RBF0400A40, calendarRangeDateSet],
  components: { SearchAcnoTemplate },
  props: {
    showOption: {
      type: Array,
      default: () => ["acno"],
    },
    defaultAcno: Object,
    title: {
      type: String,
      default: "MCOM-0000090",
    },
    buttonTitle: {
      type: String,
      default: "MCOM-0000060", //검색
    },
    acnDtailCd: {
      type: String,
    },
    isDrwotAcnoUse: {
      type: Boolean,
      default: false,
    },
    page: {
      type: String,
    },
    isNoScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      srchList: [
        "classifyInq",
        "acno",
        "acno2",
        "calRange",
        "paymtCalRange",
        "chequeNum",
        "paymentDate",
        "closingDate",
        "inotDstcd",
        "resultSeq",
        "fcResultSeq",
        "inqueryDst",
        "chnlDstcd",
        "mnrcvAcno",
        "corpBzwkCd",
        "regiWwwBnkgLginId",
      ],
      callType: "",
      actionSheetOpened: false,
      filterOpened: false,
      isCalendarOpen: false,
      inotDstcdDefault: "00",
      inotDstcdList: [
        { value: "00", text: "MCOM-0000061" }, //전체
        { value: "10", text: "MCOM-0000062" }, //입금
        { value: "20", text: "MCOM-0000063" }, //출금
      ],
      resultSeqDefault: "01", //최근 거래내역이 위로
      resultSeqList: [
        { value: "01", text: "MCOM-0000064" }, //최근 거래내역이 위로
        { value: "02", text: "MCOM-0000065" }, //과거 거래내역이 위로
      ],
      fcResultSeqDefault: "1", //최근 거래내역이 위로
      fcResultSeqList: [
        { value: "1", text: "MCOM-0000064" }, //최근 거래내역이 위로
        { value: "2", text: "MCOM-0000065" }, //과거 거래내역이 위로
      ],
      inqueryDstDefault: "0", //전체
      inqueryDstList: [
        { value: "0", text: "MCOM-0000061" }, //전체
        { value: "2", text: "MCOM-0000066" }, //예금해지
        { value: "1", text: "MCOM-0000067" }, //예금갱신
      ],
      inqueryDstList_ogmmr: [{ value: "1", text: "MCOM-0000067" }], //예금갱신
      chnlDstcdDefault: "01",
      chnlDstcdList: [
        { value: "01", text: "MCOM-0000068" }, // 대출 시작일
        { value: "02", text: "MCOM-0000069" }, //대출 종료일
      ],
      corpBzwkCdList: [], //거래 종류(결재완료내역)
      corpBzwkCdDefault: "0",
      regiWwwBnkgLginIdDefault: "0",
      aprvalStusDefault: "0",
      rmtancPtrnDstcdList: [
        { value: "98", text: "MCOM-0000061" }, //전체
        { text: this.$config.RMTANC_PTRN_DSTCD_02, value: "02" }, //NEFT
        { text: this.$config.RMTANC_PTRN_DSTCD_01, value: "01" }, //RTGS
      ],
      paymtDsticCdList: [
        // Bill Payment
        { value: "0", text: "MCOM-0000061" }, // 전체
        { value: "1", text: "MPAY-06-01-01-18" }, // 전기요금 - 다국어 필요
        { value: "2", text: "MPAY-06-01-01-21" }, // 수도요금 - 다국어 필요
      ],
      srchParam: {},
      acnoParam: {},
      acnoParam_: {},
      param_: {
        classifyInq: "", //조회구분
        tranStartYmd: "", //거래일자1
        tranEndYmd: "", //거래일자2
        paymentDate: "", // 납부일
        closingDate: "", // 해지일
        brncoInotDstcd: "", //입출분구분코드(입금/출금)
        resultSeq: "", //결과순서(최근/과거)
        fcResultSeq: "", //외화이체신청내역조회 결과순서(최근/과거)
        chequeNum: "", //수표번호
        rmtancPtrnDstcd: "98", //송금방식(인도)
        inqueryDst: "", //조회구분(해지/갱신)
        chnlDstcd: "", //조회구분(과거대출거래내역)
        mnrcvAcno: "", //입금계좌번호
        corpBzwkCd: "", //거래종류(결재완료내역)
        regiWwwBnkgLginId: "", //등록자ID(결재완료내역)
        regiWwwBnkgLginName: "", //등록자dlfma(결재완료내역)
        aprvalDstic: "", //결재 상태(결재완료내역)
        billPaymentDstcCd: "", // 납부구분코드
      },
      isActionSheetOpened: false,
      paymtDsticCdDefault: "0", // 납부구분코드 상태 ()
    };
  },
  created() {
    if (this.showOption.includes("corpBzwkCd")) {
      if (this.siteCode == this.$config.SITECODE_OGMMR || this.siteCode == this.$config.SITECODE_OGAUC) {
        this.corpBzwkCdList = [
          { value: "0", text: "MCOM-0000061" }, //전체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110010 }, //계좌간이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110020}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110020 }, //다계좌이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110030}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110030 }, //외화이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110040}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110040 }, //타행이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110050}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110050 }, //자동이체등록
          { text: `${this.$config.CORP_BZWK_APRVALCD_110052}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110052 }, //자동이체등록변경
          { text: `${this.$config.CORP_BZWK_APRVALCD_110051}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110051 }, //자동이체등록해지
          { text: `${this.$config.CORP_BZWK_APRVALCD_110070}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110070 }, //해외송금신청
          { text: `${this.$config.CORP_BZWK_APRVALCD_120010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_120010 }, //예금해지/갱신
        ];
        if (this.siteCode == this.$config.SITECODE_OGMMR) {
          this.corpBzwkCdList.push({ text: `${this.$config.CORP_BZWK_APRVALCD_110042}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110042 });
          this.corpBzwkCdList.push({ text: `${this.$config.CORP_BZWK_APRVALCD_110082}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110082 }); //급여이체(미얀마)
        }
      } else if (this.siteCode == this.$config.SITECODE_OGCBD) {
        this.corpBzwkCdList = [
          { value: "0", text: "MCOM-0000061" }, //전체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110010 }, //계좌간이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110020}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110020 }, //다계좌이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110050}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110050 }, //자동이체등록
          { text: `${this.$config.CORP_BZWK_APRVALCD_110052}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110052 }, //자동이체등록변경
          { text: `${this.$config.CORP_BZWK_APRVALCD_110051}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110051 }, //자동이체등록해지
          { text: `${this.$config.CORP_BZWK_APRVALCD_110030}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110030 }, //외화이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_120010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_120010 }, //예금해지/갱신
        ];
      } else if (this.siteCode == this.$config.SITECODE_OGHCM) {
        this.corpBzwkCdList = [
          { value: "0", text: "MCOM-0000061" }, //전체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110010 }, //계좌간이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110020}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110020 }, //다계좌이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110030}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110030 }, //외화이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110040}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110040 }, //타행이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110080}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110080 }, //타행대량이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110081}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110081 }, //타행대량이체(신규)
          { text: `${this.$config.CORP_BZWK_APRVALCD_110050}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110050 }, //자동이체등록
          { text: `${this.$config.CORP_BZWK_APRVALCD_110052}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110052 }, //자동이체등록변경
          { text: `${this.$config.CORP_BZWK_APRVALCD_110051}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110051 }, //자동이체등록해지
          { text: `${this.$config.CORP_BZWK_APRVALCD_110070}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110070 }, //해외송금신청
          { text: `${this.$config.CORP_BZWK_APRVALCD_110071}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110071 }, //해외송금신청취소
          { text: `${this.$config.CORP_BZWK_APRVALCD_110011}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110011 }, //PhoneTopup
          { text: `${this.$config.CORP_BZWK_APRVALCD_110012}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110012 }, //BillPayment
          { text: `${this.$config.CORP_BZWK_APRVALCD_140001}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140001 }, //사용자등록관리(등록)
          { text: `${this.$config.CORP_BZWK_APRVALCD_140002}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140002 }, //사용자등록관리(삭제)
          { text: `${this.$config.CORP_BZWK_APRVALCD_140003}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140003 }, //사용자등록관리(수정)
          { text: `${this.$config.CORP_BZWK_APRVALCD_140004}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140004 }, //결재단계설정/수정
          { text: `${this.$config.CORP_BZWK_APRVALCD_140005}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140005 }, //사용자별보안매체관리(해제)
          { text: `${this.$config.CORP_BZWK_APRVALCD_140006}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_140006 }, //사용자별보안매체관리(등록/변경)
          // { text: `${this.$config.CORP_BZWK_APRVALCD_120010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_120010 }, //예금해지/갱신
        ];
        if (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03") {
          this.corpBzwkCdList.push({ text: `${this.$config.CORP_BZWK_APRVALCD_110041}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110041 });
        }
        // if (this.addtlInfo.includes(this.$config.ALLOW_MENU_BULK_OTRBNK)) {
        //   this.corpBzwkCdList.push({ text: `${this.$config.CORP_BZWK_APRVALCD_110081}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110081 });
        // }
      } else if (this.siteCode == this.$config.SITECODE_OGIND) {
        this.corpBzwkCdList = [
          { value: "", text: "MCOM-0000061" }, //전체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110010}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110010 }, //계좌간이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110020}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110020 }, //다계좌이체
          { text: `${this.$config.CORP_BZWK_APRVALCD_110040}_결재선사용거래`, value: this.$config.CORP_BZWK_APRVALCD_110040 }, //타행이체
        ];
      }
    }

    if (this.showOption.includes("regiWwwBnkgLginId") && this.regiWwwBnkgLginIdList.length == 0) {
      this.$post("/customer/aprv/UserRegiMgtInq", {}, this.RBF0409I40Suc);
    }

    let date = this.changeDate(
      this.defaultRangeIndex,
      this.$route.name == "mmrSalaryApplyRsultInq"
        ? this.sessionInfo.userInfo.nxbizYmd || this.$getDateToString(this.sessionInfo.userInfo.nxbizYmd)
        : this.srchParam.tranEndYmd || this.$getDateToString(),
    );
    this.$set(this.param_, "tranStartYmd", date.start);
    this.$set(this.param_, "tranEndYmd", date.end);

    if (_.isEmpty(this.srchParam)) {
      this.$set(this.param_, "brncoInotDstcd", this.inotDstcdDefault);
      this.$set(this.param_, "resultSeq", this.resultSeqDefault);
      this.$set(this.param_, "fcResultSeq", this.fcResultSeqDefault);
      this.$set(this.param_, "inqueryDst", this.siteCode == this.$config.SITECODE_OGMMR ? "1" : this.inqueryDstDefault);
      this.$set(this.param_, "chnlDstcd", this.chnlDstcdDefault);
      this.$set(this.param_, "corpBzwkCd", this.corpBzwkCdDefault);
      this.$set(this.param_, "regiWwwBnkgLginId", this.regiWwwBnkgLginIdDefault);
      this.$set(this.param_, "aprvalDstic", this.aprvalStusDefault);
      // billPayment로 거래내역조회할때 라우터로 넘어온 값을 셋하기
      if (this.showOption.includes("paymtCalRange")) {
        this.$set(this.param_, "billPaymentDstcCd", this.$route.params.paymtDsticCd == undefined ? this.paymtDsticCdDefault : this.$route.params.paymtDsticCd);
      }
      this.srchParam = { ...this.param_ };
    }

    //계좌번호 옵션이 없을때는 전계좌조회 호출 pass, 검색 호출
    if (!this.showOption.includes("acno") && !this.showOption.includes("acno2")) {
      this.callType = "option";
    }
  },
  mounted() {},
  computed: {
    ...mapFields(["siteCode", "sessionInfo", "addtlInfo"]),
    ...mapFields("admin", ["regiWwwBnkgLginIdList"]),
    ...mapGetters(["isUserOtpDstcd"]),
    slots() {
      if (this.$slots.tag) {
        this.$set(this.param_, "mnrcvAcno", this.$slots.tag[0].componentOptions.propsData.text);
        return this.$slots.tag[0].componentOptions.propsData.text;
      } else {
        this.$set(this.param_, "mnrcvAcno", "");
        return "";
      }
    },
    filterOpeneded: {
      get() {
        return this.filterOpened;
      },
      set(v) {
        this.filterOpened = v;
        this.$nextTick(() => {
          if (this.showOption.includes("corpBzwkCd")) {
            if (this.$refs.corpBzwkCd) {
              this.$refs.corpBzwkCd.setValue(this.param_.corpBzwkCd);
            }
          }

          if (this.showOption.includes("acno2")) {
            if (this.$refs.acno2) {
              this.$refs.acno2.setValue(this.param_.acno2);
            }
          }

          if (this.showOption.includes("regiWwwBnkgLginId")) {
            if (this.$refs.regiWwwBnkgLginId) {
              this.$refs.regiWwwBnkgLginId.setValue(this.param_.regiWwwBnkgLginId);
            }
          }
        });
      },
    },
    regiWwwBnkgLginName() {
      let info = _.filter(this.regiWwwBnkgLginIdList, { value: this.srchParam.regiWwwBnkgLginId });
      if (info.length > 0 && info[0].text != "MCOM-0000061") {
        return info[0].text;
      } else {
        return "";
      }
    },
  },
  methods: {
    async acnoInitValue() {
      if (this.isDrwotAcnoUse) {
        this.list = await this.RBF0400A40CallDrwot();
        this.list.forEach(item => {
          this.$set(item.data, "bal", item.data.dpostBal);
        });
      }
      if (this.showOption.includes("acno")) {
        //과거대출내역 -> 대출거래내역으로 진입 시에는 계좌정보 직접 셋팅
        if (this.$route.params.page == "rpayRsultInq") {
          this.$set(this.acnoParam, "acno", this.$route.params.acno);
          this.$set(this.acnoParam, "alias", this.$route.params.acnoAls);
          this.$set(this.acnoParam, "nxtrmPaymtYmd", this.$route.params.nxtrmPaymtYmd);
          this.$set(this.acnoParam, "lnIrt", this.$route.params.lnIrt);
          this.$set(this.acnoParam, "cncycd", this.$route.params.currencyCd);
          this.$set(this.acnoParam, "lnBal", this.$route.params.lnBal);
          this.$set(this.acnoParam, "acnDtailCd", "5");
          this.search();
        } else {
          let data = null;
          if (!_.isEmpty(this.defaultAcno)) {
            data = this.list.filter(v => v.value.split(";")[0] == this.defaultAcno.acno)[0];
          } else {
            data = this.list.length > 0 ? this.list[0] : null;
          }
          if (!_.isNil(data)) this.optionClick(data);
        }
      }
    },
    optionClick(option) {
      // let value = option.value.split(";");
      // let acno_ = option.data;
      // acno_.acno = value[0];
      // acno_.cncycd = value[1];
      // acno_.acnoAls = value[2];
      // acno_.newYmd = option.data.newYmd;
      // acno_.bal = option.data.bal;

      this.acnoParam = option.data;
      this.search();
      this.actionSheetOpened = false;
    },
    filterPopupOpen() {},
    // type : addDate 호출 type
    addDate(month, type) {
      // 이 부분 수정
      this.$set(this.param_, "tranEndYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").subtract(0, "d"))); // 하루를 뺴는 이유를 모르겠음  1 -> 0
      this.$set(this.srchParam, "tranEndYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").subtract(0, "d"))); // 하루를 뺴는 이유를 모르겠음  1 -> 0
      //this.$set(this.param_, "tranEndYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").subtract(1, "d")));
      //this.$set(this.srchParam, "tranEndYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").subtract(1, "d")));
      this.$set(this.param_, "tranStartYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").add(month, "M")._d));
      this.$set(this.srchParam, "tranStartYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").add(month, "M")._d));

      //this.$set(this.param_, "tranStartYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").add(month, "M")._d));
      //this.$set(this.srchParam, "tranStartYmd", this.$getDateToString(this.moment(this.srchParam.tranStartYmd, "YYYYMMDD").add(month, "M")._d));
      // type : addDate 호출 type
      this.$emit("search", this.srchParam, this.acnoParam, type);
    },
    confirm() {
      for (const key in this.$refs) {
        // this.$log.info(this.$refs[key].$v.$invalid);
        if (!_.isNil(this.$refs[key]) && !_.isNil(this.$refs[key].$v)) {
          this.$refs[key].$v.$touch();
        }
      }
      this.srchParam = { ...this.param_ };
      if (this.showOption.includes("acno2")) {
        this.acnoParam = this.acnoParam_;
      }
      this.search();
      this.filterOpeneded = false;
    },
    search() {
      let acnoReady = false;
      let srchReady = false;
      if (this.showOption.includes("acno")) {
        if (!_.isEmpty(this.acnoParam)) acnoReady = true;
      } else acnoReady = true;

      if (!(this.showOption.length == 1 && this.showOption[0] == "acno")) {
        if (!_.isEmpty(this.srchParam)) srchReady = true;
      } else srchReady = true;

      this.$log.info(acnoReady, srchReady);
      /*
      if (this.srchParam.billPaymentDstcCd != undefined && this.srchParam.billPaymentDstcCd != "") {
        this.$set(this.param_, "billPaymentDstcCd", this.srchParam.billPaymentDstcCd);
      } else {
        this.$set(this.param_, "billPaymentDstcCd", this.$route.params.paymtDsticCd == undefined ? "0" : this.$route.params.paymtDsticCd);
      }
*/
      if (acnoReady && srchReady) {
        this.$emit("search", this.srchParam, this.acnoParam);
      }
    },
    // 결제내역조회(BillPayment)

    search2() {
      let acnoReady = false;
      let srchReady = false;
      if (this.showOption.includes("acno")) {
        if (!_.isEmpty(this.acnoParam)) acnoReady = true;
      } else acnoReady = true;

      if (!(this.showOption.length == 1 && this.showOption[0] == "acno")) {
        if (!_.isEmpty(this.srchParam)) srchReady = true;
      } else srchReady = true;

      this.$log.info(acnoReady, srchReady);
      if (this.srchParam.billPaymentDstcCd != undefined && this.srchParam.billPaymentDstcCd != "") {
        this.$set(this.param_, "billPaymentDstcCd", this.srchParam.billPaymentDstcCd);
      } else {
        this.$set(this.param_, "billPaymentDstcCd", this.$route.params.paymtDsticCd == undefined ? "0" : this.$route.params.paymtDsticCd);
      }

      this.srchParam = { ...this.param_ };
      if (acnoReady && srchReady) {
        this.$emit("search", this.srchParam, this.acnoParam);
      }
    },

    RBF0409I40Suc(res) {
      let tmp = [];
      tmp.push({ value: "0", text: "MCOM-0000061" }); //전체
      for (const data of res.outItem.otpListGrid) {
        tmp.push({ text: data.userName, value: data.userIdnfr });
      }
      this.regiWwwBnkgLginIdList = tmp;
    },
    acno2Change(e) {
      this.acnoParam_ = e;
    },
    regiWwwBnkgLginIdChange(e) {
      this.$set(this.param_, "regiWwwBnkgLginName", e.text);
    },
    hideSearchButton() {
      if (
        (!_.isEmpty(this.$refs.corpBzwkCd) && this.$refs.corpBzwkCd.actionSheetOpend) ||
        (!_.isEmpty(this.$refs.regiWwwBnkgLginId) && this.$refs.regiWwwBnkgLginId.actionSheetOpend) ||
        (!_.isEmpty(this.$refs.acno2) && this.$refs.acno2.$refs.acno.actionSheetOpend)
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>
